import images from './images';

const cakes = [
  {
    title: 'Chapel Hill Shiraz',
    price: '$25',
    tags: 'AUE | Tray',
  },
  {
    title: 'Wegmans Ultimate White Cake Slice',
    price: '$15',
    tags: 'AUE | Tray',
  },
  {
    title: 'Mini Premium Chocolate Cream Pie',
    price: '$12',
    tags: 'AUE | Tray',
  },
  {
    title: 'Fruit Tart Trifle',
    price: '$15',
    tags: 'AUE | Tray',
  },
  {
    title: 'Small Ultimate Plain Cheesecake',
    price: '$20',
    tags: 'AUE | Tray',
  },
]; 

const juices = [
  {
    title: 'Lemon Juice Mint',
    price: '$20',
    tags: 'Lemon | Villa Marchesi prosecco | soda | 30 ml',
  },
  {
    title: "Pinacoloda",
    price: '$16',
    tags: 'chocolate | Lemon | Slice of lime',
  },
  {
    title: 'Strawberry Juice (P.O.A )',
    price: '$10',
    tags: 'Milk | Citrus juice | Sugar',
  },
  {
    title: 'Magic Mango',
    price: '$30',
    tags: 'Mango | Brown sugar | Angostura Bitters',
  },
  {
    title: 'Fruit Punch',
    price: '$25',
    tags: 'Milk | Sweet Vermouth | Campari | Orange garnish',
  },
];

const awards = [
  {
    imgUrl: images.award02,
    title: 'Bib Gourmond',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award01,
    title: 'Rising Star',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award05,
    title: 'AA Hospitality',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
  {
    imgUrl: images.award03,
    title: 'Outstanding Chef',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur.',
  },
];

export default { juices, cakes, awards };
